import { render, staticRenderFns } from "./Reynsluakstur.vue?vue&type=template&id=0605cbdf"
import script from "./Reynsluakstur.vue?vue&type=script&lang=js"
export * from "./Reynsluakstur.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports